function Slider() {
  return (
    <section className="gold h-max py-[80px] bg-gray-100">
      <h1 className="text-center head text-[5rem] ">
        What do you celebrate today{" "}
      </h1>{" "}
      <div className="flex justify-evenly mt-[50px] px-[10%] flex-wrap">
        <div className="flex flex-col mb-[20px] h-[600px] w-[400px]  items-center justify-between">
          <div className="slider-img1 bg-img h-[100%] w-[100%]"> </div>{" "}
          <div className="flex items-center justify-between w-[100%] my-[20px]">
            <h1 className="head text-[2.5rem]"> Pasadena </h1>{" "}
            <p className="text-[1.2rem]"> $ 12.00 </p>{" "}
          </div>
        </div>{" "}
        <div className="flex flex-col mb-[20px] h-[600px] w-[400px]  items-center justify-between">
          <div className="slider-img2 bg-img h-[100%] w-[100%]"> </div>{" "}
          <div className="flex items-center justify-between w-[100%] my-[20px]">
            <h1 className="head text-[2.5rem]"> Le Lavandou </h1>{" "}
            <p className="text-[1.2rem]"> $ 9.50 </p>{" "}
          </div>
        </div>{" "}
        <div className="flex flex-col mb-[20px] h-[600px] w-[400px]  items-center justify-between">
          <div className="slider-img3 bg-img h-[100%] w-[100%]"> </div>{" "}
          <div className="flex items-center justify-between w-[100%] my-[20px]">
            <h1 className="head text-[2.5rem]"> Dominicana </h1>
            <p className="text-[1.2rem]"> $ 10.00 </p>
          </div>
        </div>
      </div>
    </section>
  );
}
export { Slider };
